<form novalidate #currentForm="ngForm">
  <div class="setup">
    <div class="section-container">
      <div class="label-data label">
        <div class="label"><b>Name</b></div>
      </div>
      <div class="group stream-data">
        <input
          matInput
          autocomplete="off"
          type="text"
          class="input-data"
          name="testName"
          #testNameInput="ngModel"
          [(ngModel)]="testName"
          (ngModelChange)="nameUpdated()"
          maxlength="80"
          required
        />
        <div
          class="error"
          *ngIf="testNameInput.invalid && (testNameInput.dirty || testNameInput.touched)"
        >
          <mat-error *ngIf="testNameInput?.errors?.required">Name is required</mat-error>
          <mat-error *ngIf="testNameInput.errors.regex && !testNameInput.errors.required"
            >Name should not contain '?,%,/' special characters</mat-error
          >
        </div>
        <div *ngIf="nameExist">
          <mat-error>Name already exist</mat-error>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="label-data label">
        <div class="label"><b>Codec</b></div>
      </div>
      <div class="group stream-data">
        <mat-select
          class="option-list codec-value-select"
          name="codec"
          required
          [(ngModel)]="defaultCodec"
          (ngModelChange)="changeCodecValue()"
        >
          <mat-option *ngFor="let codec of codecList" [value]="codec.name">
            {{ codec.name }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="section-container">
      <div class="label-data label"><b>Schedule</b></div>
      <div class="scheduler-section">
        <div class="section-data">
          <div class="group start-input">
            <div class="label">Starts</div>
            <input
              matInput
              autocomplete="off"
              type="text"
              class="input-data disabled"
              name="startScheduleVal"
              [(ngModel)]="startScheduleVal"
              disabled
            />
          </div>
          <div class="group repeat-DD">
            <div class="label">Repeats</div>
            <mat-select
              class="option-list disabled"
              #repeatScheduleValInput="ngModel"
              name="repeatScheduleVal"
              [(ngModel)]="repeatScheduleVal"
              disabled
            >
              <mat-option value="1min">Every 1 minute</mat-option>
            </mat-select>
          </div>
          <div class="group repeat-DD">
            <div class="label">Ends</div>
            <mat-select
              class="option-list"
              [ngClass]="{ disabled: editMode }"
              #endScheduleValInput="ngModel"
              name="endScheduleVal"
              (ngModelChange)="onEndScheduleValChange($event)"
              [(ngModel)]="endScheduleVal"
              [disabled]="editMode"
              required
            >
              <mat-option *ngIf="!isDisabledScheduler" value="on-going"> Never </mat-option>
              <mat-option value="on-demand"> In 8 hours</mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="label-data label"><b>Endpoints</b></div>
      <div [ngClass]="{ 'site-section': showSipId }">
        <div class="site-section">
          <div class="container-flex">
            <div>
              <nrwl-agent-picker
                [testType]="'voip'"
                [originatorDevice]="selectedDeviceOriginator"
                [destinationDevice]="selectedDeviceDestination"
                [editMode]="editMode"
                [testMode]="testMode"
                [showTestMode]="false"
                [showDestination]="showDestination"
                (emitAgents)="onAgentChange($event)"
              ></nrwl-agent-picker>
              <div class="proxy-container">
                <div class="proxy">
                  SIP proxy : {{ proxyOriginator }}
                  <a (click)="changeOriginatorProxy()">Change proxy</a>
                </div>
                <div class="proxy-content" *ngIf="hasOriginatorProxy && !showSipId">
                  <div class="destination_proxy">
                    <div class="destination-proxy">
                      SIP proxy : {{ proxyDestination }}
                      <a (click)="changeDestinationProxy()">Change proxy</a>
                      <div
                        *ngIf="!hasDestinationProxy && selectedDestination.length"
                        class="error-proxy"
                      >
                        Proxy required
                      </div>
                    </div>
                    <div class="destination-proxy">
                      <!-- <a (click)="selectSipId()" class="border-bottom">{{ toggleMessage }}</a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="sip-container" *ngIf="showSipId">
              <span class="destination">Destination</span>
              <div class="sipId">
                <span class="destination-1">Or, select a phone number or SIP ID</span>
                <input
                  #sipPhoneNumber
                  autocomplete="off"
                  class="input-data"
                  [(ngModel)]="sipPhoneNumberValue"
                  (keyup)="sipPhoneNumberCheck()"
                />
                <div>
                  <mat-error *ngIf="!isValidSIPPhoneOrUserId && sipPhoneNumberValue"
                    >Please enter proper phone number or sipid</mat-error
                  >
                </div>
              </div>
              <div *ngIf="hasOriginatorProxy" class="destination-proxy-1">
                <!-- <a (click)="selectSipId()" class="border-bottom">{{ toggleMessage }}</a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="label-data label">
        <div class="label"><b>Threshold</b></div>
        <span class="sub-text">(MOS)</span>
      </div>
      <div class="group stream-data">
        <div class="section-data">
           <div class="group threshold-input">
            <div class="label">Warning</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data"
              name="thresholdForWarning"
              [(ngModel)]="thresholdForWarning"
              (ngModelChange)="onChangeThreshold()"
              #thresholdForWarningInput="ngModel"
              [min]="warningThersholds.min"
              [max]="warningThersholds.max"
              required
            />
            <mat-error *ngIf="thresholdForWarningInput?.errors?.required"> Required</mat-error>
            <mat-error *ngIf="thresholdForWarningInput.errors?.min || thresholdForWarningInput.errors?.max">
              value should be {{warningThersholds.min}} to {{ warningThersholds.max }}
            </mat-error>
          </div>
           <div class="group threshold-input">
            <div class="label">Critical</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data"
              name="thresholdForCritical"
              [(ngModel)]="thresholdForCritical"
              (ngModelChange)="onChangeThreshold()"
              #thresholdForCriticalInput="ngModel"
              [min]="criticalThersholds.min"
              [max]="criticalThersholds.max"
              required
            />
            <mat-error *ngIf="thresholdForCriticalInput?.errors?.required"> Required</mat-error>
            <mat-error *ngIf="thresholdForCriticalInput.errors?.min || thresholdForCriticalInput.errors?.max">
              value should be {{criticalThersholds.min}} to {{ criticalThersholds.max }}
            </mat-error>
          </div>
        </div>

      </div>
    </div>
  </div>
</form>
